import { SettlementEntity } from '../entities/settlement-entity';

export default class State {
  current_codigo_postal = '';

  items: Array<SettlementEntity> = [];
}
